import React, { useMemo, Fragment } from 'react';
var isNil = function isNil(val) {
  return val === undefined || val === null;
};
var getBoolVal = function getBoolVal(val) {
  if (typeof val === 'string') {
    return val === 'true';
  }
  return !!val;
};
var useFeature = function useFeature(_ref) {
  var name = _ref.name,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled;
  var cookies = useMemo(function () {
    if (!global.window) {
      return {};
    }
    return document.cookie.split(';').map(function (cookie) {
      return cookie.replace(' ', '');
    }).reduce(function (acc, cookie) {
      var _Object$assign;
      return Object.assign(acc, (_Object$assign = {}, _Object$assign[cookie.split('=')[0]] = cookie.split('=')[1], _Object$assign));
    }, {});
  }, []);
  var featureEnabled = useMemo(function () {
    var _global, _global$window, _global$window$localS, _process$env, _process$env2, _process$env3, _process$env4, _process$env5;
    var urlSearchParams = global.window && new URLSearchParams(global.window.location.search);
    var myParam = urlSearchParams ? urlSearchParams.get(name) : null;
    var localStorageValue = (_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$localS = _global$window.localStorage) === null || _global$window$localS === void 0 ? void 0 : _global$window$localS.getItem(name);
    var envVar = ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env[name]) || ((_process$env2 = process.env) === null || _process$env2 === void 0 ? void 0 : _process$env2["REACT_APP_" + name]) || ((_process$env3 = process.env) === null || _process$env3 === void 0 ? void 0 : _process$env3["GATSBY_" + name]) || ((_process$env4 = process.env) === null || _process$env4 === void 0 ? void 0 : _process$env4["NEXT_PUBLIC_" + name]) || ((_process$env5 = process.env) === null || _process$env5 === void 0 ? void 0 : _process$env5["VITE_" + name]);
    if (!isNil(myParam)) {
      return getBoolVal(myParam);
    }
    if (!isNil(cookies[name])) {
      return getBoolVal(cookies[name]);
    }
    if (!isNil(localStorageValue)) {
      return getBoolVal(localStorageValue);
    }
    if (!isNil(envVar)) {
      return getBoolVal(envVar);
    }
    return !!enabled;
  }, [name, enabled, cookies]);
  return featureEnabled;
};
var Feature = function Feature(_ref) {
  var name = _ref.name,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    children = _ref.children;
  var flagEnabled = useFeature({
    name: name,
    enabled: enabled
  });
  return React.createElement(Fragment, null, flagEnabled && children);
};
export { Feature, useFeature };